import * as React from 'react';

export const renderHelpText = (text: string): React.ReactNode => {
    const lines = text.split('\n');
    const result: React.ReactNode[] = [];
    let bulletGroup: string[] = [];

    const flushBullets = () => {
        if (bulletGroup.length) {
            result.push(
                <ul key={`ul-${result.length}`} style={{ paddingLeft: 'var(--spacer-M)', marginTop: 'var(--spacer-XS)', marginBottom: 'var(--spacer-XS)' }}>
                    {bulletGroup.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
            );
            bulletGroup = [];
        }
    };

    lines.forEach(line => {
        if (line.trimStart().startsWith('-')) {
            bulletGroup.push(line.substring(line.indexOf('-') + 1).trim());
        } else {
            flushBullets();
            result.push(<div key={result.length}>{line}</div>);
        }
    });

    flushBullets();
    return result;
};
